import { render, staticRenderFns } from "./UpperFuzziMatching.vue?vue&type=template&id=957a2522&scoped=true"
import script from "./UpperFuzziMatching.vue?vue&type=script&lang=js"
export * from "./UpperFuzziMatching.vue?vue&type=script&lang=js"
import style0 from "./UpperFuzziMatching.vue?vue&type=style&index=0&id=957a2522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957a2522",
  null
  
)

export default component.exports